// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceSpace',
    standalone: false
})
export class ReplaceSpacePipe implements PipeTransform {

  transform(value: string, replaceValue = '-'): string {
    replaceValue = replaceValue === null ? '-' : replaceValue;
    return value.replace(/ /g, replaceValue);
  }

}
